

















































































































































import {
  defineComponent,
  ComponentInternalInstance,
  getCurrentInstance,
  onUnmounted,
  computed,
  onMounted,
  ref,
  toRefs,
  reactive,
  watch,
} from '@vue/composition-api';
import { EllipsisIcon, ChevronLeftIcon } from 'tdesign-icons-vue';
import lottie from 'lottie-web';
// 引入组件
import userAvatar from '@/renderer/components/user/components/userAvatar.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import LoginPage from '@/renderer/components/login/components/index.vue';
import Transmission from '@/renderer/components/SpacePage/components/Transmission.vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import Advert from '@/renderer/components/common/Advert.vue';
import noticeDialog from '@/renderer/views/message/index.vue';
import PrivateClientDownloadDialog from '@/renderer/components/browser/PrivateClientDownloadDialog/index.vue';
import Announcement from '@/renderer/views/desktop/headbar/components/GeneralHeader/announcement.vue';
import { DrawerEvents } from '@/renderer/store/modules/drawer';

// 引入 compositions
import searchHandler from '@/renderer/scripts/composition/searchHandler';
import rendererHandler from '@/renderer/views/desktop/headbar/composition/generalRendererHandler';
import baseHeadbarHandler from '@/renderer/views/desktop/headbar/composition/baseHeadbarHandler';
import transmissionListHandle from '@/renderer/views/desktop/FileManagement/Transmission/transmissionListHandle';

// 引入工具类
import { getOfficialWebsiteUrl } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc from '@/renderer/scripts/utils/ipc';
import { httpUrl } from '@/renderer/scripts/http';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import '@/renderer/assets/images/Icon/svg/toolbox/toolbox.svg';
import '@/renderer/assets/images/Icon/svg/toolbox/toolbox-esign.svg';
import '@/renderer/assets/images/Icon/svg/toolbox/toolbox-file-collect.svg';
import { IS_BROWSER, IS_BROWSER_IN_MOBILE, IS_PRIVATE } from '@/common/constant/platform';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';
import { i18n_t } from '@/locales/i18n';
import transmissionNumHandler from './composition/transmissionNumHandler';
import headerAdvertHandler from './composition/headerAdvertHandler';

export default defineComponent({
  components: {
    EllipsisIcon,
    ChevronLeftIcon,
    userAvatar,
    LoginPage,
    Advert,
    Transmission,
    BaseIcon,
    noticeDialog,
    SettingDialog,
    PrivateClientDownloadDialog,
    Announcement,
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const isOpenDrawer = computed(() => store.getters.drawerShow); // 腾讯会议中初始化默认抽屉关闭
    // 是否有搜索入口
    const searchAvailable = computed(() => vm.$route?.meta?.searchAvailable === true);
    const showReturnSearch = computed<boolean>(() => vm.$route?.query?.fromRoute === 'search');
    const settingInfo = reactive({
      defaultPage: '',
    }); // 设置中心默认展示页面
    const { envHelp, goToIndexPage } = baseHeadbarHandler();
    const { methods: headBarMethods, orgLogo, orgName, showSetting, showLogin, isShareRoute } = rendererHandler();
    const { transmissionNum } = transmissionNumHandler();
    const { hasRunningTask } = transmissionListHandle();
    const { searchKeyword, methods: searchMethods } = searchHandler();
    const { tipData, methods: advertMethods } = headerAdvertHandler();
    const strMsgNum = computed(() => {
      const msgNum = vm.$store.getters.messageNumber as number;
      if (msgNum > 99) {
        return '99+';
      }
      return msgNum.toString();
    });
    const showReturnTips = ref(false); // 手动控制tooltip的实现
    const showTips = ref(false);
    const rendererBar = computed(() => {
      const { editionFlag, userBaseInfo } = store.getters;
      const { isTemporary, userId } = userBaseInfo;
      return {
        envHelp: !!envHelp.value,
        setting: !IS_BROWSER,
        notification: !IS_BROWSER_IN_MOBILE && store.getters.isLogined,
        userManual: !IS_BROWSER_IN_MOBILE,
        transList: !IS_BROWSER_IN_MOBILE,
        toolbox: editionFlag === 'enterprise' && !isTemporary && userId !== -1, // 用户信息为空时不显示工具箱
      };
    });

    let lottieAnimation: any = null;
    const showTransAnimation = ref(false);
    const drawerShow = computed(() => store.getters.drawerShow);
    const toolboxShow = ref(IS_PRIVATE ? windowEnvs.toolBox.length > 1 : true);
    const showDownloadAppBtn = ref((IS_BROWSER && !IS_PRIVATE) || windowEnvs.showDownloadAppBtnInPc);
    const showPrivateClientDownloadDialog = ref(false);

    const toolBoxItem = {
      esign: {
        icon: 'toolbox-esign',
        text: i18n_t('发起电子签'),
      },
      fileCollect: {
        icon: 'toolbox-file-collect',
        text: i18n_t('文件收集'),
      },
    };
    type toolBoxItemType = keyof typeof toolBoxItem;
    const nonToolBoxItem = computed(() => {
      const iconType = windowEnvs.toolBox[0] ? windowEnvs.toolBox[0] : 'fileCollect';
      return {
        icon: getToolBoxItemIconType(iconType),
        text: getToolBoxItemIconText(iconType),
      };
    });

    const getToolBoxItemIconType = (itemType: string) => {
      if (Object.keys(toolBoxItem).includes(itemType)) {
        return toolBoxItem[itemType as toolBoxItemType].icon;
      }
      return toolBoxItem.fileCollect.icon;
    };

    const getToolBoxItemIconText = (itemType: string) => {
      if (Object.keys(toolBoxItem).includes(itemType)) {
        return toolBoxItem[itemType as toolBoxItemType].text;
      }
      return toolBoxItem.fileCollect.text;
    };

    const showToolBoxItem = (itemType: string) => {
      if (!IS_PRIVATE) {
        return true;
      }

      if (Object.keys(toolBoxItem).includes(itemType) && windowEnvs.toolBox) {
        if (windowEnvs.toolBox.includes(itemType)) {
          return true;
        }
      }
      return false;
    };

    const methods = {
      toggleDrawer(val: Boolean) {
        vm.$store.commit(DrawerEvents.TOGGLE_DRAWER, !val);
      },
      showLoginFun() {
        showLogin.value = true;
      },
      transShowChange() {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.NOTICE_CENTER_SHOW, {
          show: false,
        });
        ipc.emit(ipc.RENDERER_EVENTS_MAP.TRANS_SHOW_CHANGE);
      },
      openDownloadPC() {
        if (IS_PRIVATE) {
          showPrivateClientDownloadDialog.value = true;
          return;
        }
        const downloadUrlInBrowser = `${getOfficialWebsiteUrl()}/download`;
        dispatchRouter(downloadUrlInBrowser);
      },
      onSelectToolbox(params: { value: 'esign' | string }) {
        switch (params.value) {
          case 'esign': {
            dispatchRouter({
              name: 'electronicSign',
            });
            break;
          }
          case 'fileCollect': {
            dispatchRouter({
              name: 'fileCollect',
            });
            break;
          }
          default: {
            break;
          }
        }
      },
      onNonToolBoxItemClick() {
        const type = windowEnvs.toolBox[0] ? windowEnvs.toolBox[0] : 'fileCollect';
        methods.onSelectToolbox({ value: type });
      },
      showDownloadTips() {
        showTips.value = true;
        setTimeout(() => {
          showTips.value = false;
        }, 5000);
      },
      showSettingDlg(info: { defaultPage: string }) {
        showSetting.value = true;
        if (info && info.defaultPage) {
          settingInfo.defaultPage = info.defaultPage;
        }
      },
      onReturnSearch() {
        showReturnTips.value = false;
        store.commit('SET_INIT_CONDITION_DATA', true);
        dispatchRouter({
          name: 'search',
          query: {
            keyword: store.getters.searchKeyWord,
          },
        });
      },
      // 传输动画
      initImgAnimation() {
        const img: Element = document.querySelector('.trans-icon-content') as Element;
        lottieAnimation = lottie.loadAnimation({
          container: img,
          // 包含动画的dom元素
          renderer: 'svg',
          // 渲染出来的是什么格式
          loop: true,
          // 循环播放
          autoplay: true,
          // 自动播放
          path: `${httpUrl.staticCDNUrl}/tools/images/transAnimation/data.json`, // 动画json的路径
        });
        // 动图加载完成
        lottieAnimation.addEventListener('data_ready', () => {
          showTransAnimation.value = true;
          lottieAnimation.removeEventListener('data_ready');
        });
        lottieAnimation.addEventListener('data_failed', () => {
          showTransAnimation.value = false;
          lottieAnimation.removeEventListener('data_failed');
        });
      },
    };
    watch(
      () => hasRunningTask.value,
      val => {
        if (val) {
          if (!lottieAnimation) {
            methods.initImgAnimation();
          } else {
            lottieAnimation.play();
          }
        } else {
          lottieAnimation && lottieAnimation.stop();
        }
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW, methods.showLoginFun);
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_DOWNLOAD_TIPS, methods.showDownloadTips);
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_SETTING_DLG, methods.showSettingDlg);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW, methods.showLoginFun);
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_DOWNLOAD_TIPS, methods.showDownloadTips);
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_SETTING_DLG, methods.showSettingDlg);
    });
    return {
      rendererBar,
      envHelp,
      orgLogo,
      orgName,
      showSetting,
      showLogin,
      ConstantConfig,
      hasRunningTask,
      showTransAnimation,
      isShareRoute,
      goToIndexPage,
      ...toRefs(tipData),
      ...headBarMethods,
      ...methods,
      ...advertMethods,
      searchAvailable,
      showReturnSearch,
      searchKeyword,
      searchMethods,
      showReturnTips,
      showTips,
      isOpenDrawer,
      transmissionNum,
      drawerShow,
      strMsgNum,
      settingInfo,

      // 工具箱相关
      toolboxShow,
      nonToolBoxItem,
      getToolBoxItemIconType,
      getToolBoxItemIconText,
      showToolBoxItem,

      showDownloadAppBtn,
      showPrivateClientDownloadDialog,

      dispatchRouter,
    };
  },
});
